import { Button, CardActions, CardContent, Tooltip } from '@mui/material'
import './styles/IssueItem.scss'
import { Issue } from '../../types/models/Issue'
import { parseDateString } from '../../helpers/parseDateString'
import { userFioToString } from '../../helpers/userFioToString'

import { IoConstructOutline, IoStarHalfOutline, IoWarningOutline } from 'react-icons/io5'

type Props = {
  issue: Issue
  noAction?: boolean
  lite?: boolean
  onAccepted?: () => any
  onComplite?: () => any
  onEnd?: () => any
}

const IssueItem = (props: Props) => {
  const { onAccepted, onComplite, onEnd, issue, noAction, lite } = props

  const isAccepted = !!issue.takeTime
  const isComplite = !!issue.compliteTime

  const path = issue.locationPath ?? 'неизвестно'

  if (lite) {
    return (
      <div
        className={`IssueItem lite ${issue.urgent ? 'urgent' : ''} ${isAccepted ? 'accepted' : 'open'} ${
          isComplite ? 'complite' : ''
        }`}
        onClick={isComplite ? onEnd : isAccepted ? onComplite : onAccepted}
      >
        <Tooltip title={issue.device?.name}>
          <h5 className="IssueItem-card-device lite">{issue.device?.name}</h5>
        </Tooltip>
  
        {!noAction ? (
          <div className="IssueItem-card-action lite">
            {isComplite ? (
              <>
                <IoStarHalfOutline
                  className="IssueItem-card-worker-icon"
                  size={32}
                />
                <p className="IssueItem-card-author lite">
                  Заявка №{issue.id}<br />
                  <span>Автор: </span>
                  {issue.author ? userFioToString(issue.author) : ''}
                </p>
                <Button>Оценить</Button>
              </>
            ) : isAccepted ? (
              <>
                <IoConstructOutline
                  className="IssueItem-card-worker-icon"
                  size={32}
                />
                <p className="IssueItem-card-worker lite">
                  Заявка №{issue.id}<br />
                  <span>Работает: </span>
                  {issue.worker ? userFioToString(issue.worker) : ''}
                </p>
                <Button>Завершить</Button>
              </>
            ) : (
              <>
                <IoWarningOutline
                  className="IssueItem-card-worker-icon"
                  size={32}
                />
                <p className="IssueItem-card-role lite">
                  Заявка №{issue.id}<br />
                  <span>Требуется: </span>{issue.role?.value ?? 'Любой'}
                </p>
                <Button>Взять</Button>
              </>
            )}
          </div>
        ) : null}
      </div>
    )
  } // if (lite)

  return (
    <div
      className={`IssueItem ${issue.urgent ? 'urgent' : ''} ${isAccepted ? 'accepted' : 'open'} ${
        isComplite ? 'complite' : ''
      }`}
    >
      <CardContent className="IssueItem-card">
        <Tooltip title={path}>
          <p className="IssueItem-card-location">{path}</p>
        </Tooltip>
        <p className="IssueItem-card-role">{issue.role?.value ?? 'Любой'}</p>
        <h5 className="IssueItem-card-device">{issue.device?.name}</h5>

        {issue.cause ? (
          <p className="IssueItem-card-cause">{issue.cause.description}</p>
        ) : (
          <p className="IssueItem-card-cause none">Причина не указана</p>
        )}
        <p className="IssueItem-card-author">
          {issue.author ? userFioToString(issue.author) : ''}
        </p>
        <div className="IssueItem-card-time">
          №{issue.id}<br />
          {parseDateString(issue.updatedAt)}
        </div>
      </CardContent>
      {!noAction ? (
        <CardActions>
          {issue.compliteTime ? (
            <Button onClick={onEnd}>Оценить</Button>
          ) : isAccepted ? (
            <>
              <Button onClick={onComplite}>Завершить</Button>
              <p className="IssueItem-card-worker">
                <span>Работает: </span>
                {issue.worker ? userFioToString(issue.worker) : null}
              </p>
            </>
          ) : (
            <Button onClick={onAccepted}>Взять</Button>
          )}
        </CardActions>
      ) : null}
    </div>
  )
}

export default IssueItem
